import { TFunction } from "i18next";
import { TranslateVisualSensorType } from "../../Misc/TranslateVisualSensorType";
import { AlarmEnum, TSensorTypes } from "../../../types/generated_types";

export function specialTypeName(arg: string, t: TFunction<string>): string {
  switch (arg.toUpperCase()) {
    case AlarmEnum.WFL: {
      return t("Full water bucket");
    }
    case AlarmEnum.RED: {
      return t("Technical alarm");
    }
    case AlarmEnum.PAS: {
      return t("Passive");
    }
    default: {
      return TranslateVisualSensorType(arg as TSensorTypes);
    }
  }
}

// This regex checks if the input is in the correct format, they can also be negative numbers
// This selects the correct format numbers: -56.2 or +23,45
export const negativeNumberInputRegex = /^[-+]?\d*([,.]\d*)?$/;

